export const CloseButton = {
  baseStyle: {
    color: 'tealButton',
    _hover: {
      color: 'white',
    },
  },
}
